import { useState, useCallback } from 'react';
import { permissionService } from '@/services/api';
import type { Permission } from '@/types/application/models/service/permission-model-responses';
import type { UsePermissionsReturn } from '@/types/application/common/hooks/use-permissions';

export function usePermissions(): UsePermissionsReturn {
  const [permissions, setPermissions] = useState<Permission[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const refresh = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await permissionService.listPermissions();
      setPermissions(data);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to load permissions');
    } finally {
      setLoading(false);
    }
  }, []);

  return { permissions, loading, error, refresh };
}

export default usePermissions;

